import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import Fatura from "../models/fatura";
import BaseDb from "./baseDb";

export default class FaturaDb extends BaseDb<
  Fatura,
  { usuarioId: string; assinaturaId: string; faturaId: string }
> {
  _path: string =
    "usuarios/usuarioId/subscriptions/assinaturaId/invoices/faturaId";
  getConverter(): FirestoreDataConverter<Fatura> {
    return {
      fromFirestore: (snapshot, _options) => {
        return {
          id: snapshot.id,
          descricao: snapshot.get("lines").data[0].description,
          periodoInicio: moment.unix(
            snapshot.get("lines").data[0].period.start
          ),
          periodoFim: moment.unix(snapshot.get("lines").data[0].period.end),
          pdf: snapshot.get("invoice_pdf"),
          situacao: snapshot.get("status"),
          total: snapshot.get("total") / 100,
          pagoEm: moment.unix(snapshot.get("status_transitions").paid_at),
          criadoEm: moment.unix(snapshot.get("created")),
        } as Fatura;
      },
      toFirestore: (_fatura: Fatura) => {
        throw new Error("Não é possível criar um pagamentos");
      },
    };
  }
}
